export default __webpack_public_path__ + "f18a53896aeb98e55ca835fb125ee437.png";